<template>
    <div class="login" style="display: flex; justify-content: center" @keyup.enter="login">
        <!-- input -->
        <div class="hw100">
            <div class="loginBox" v-if="!isAdmin">
                <div class="caigouTitle">
                    <!-- VUE_APP_MODE: {{ VUE_APP_MODE }} -->
                    <!-- VUE_APP_LOGIN_TITLE: {{ VUE_APP_LOGIN_TITLE }} -->
                    <template v-if="VUE_APP_MODE !== 'demo'">
                        <img src="../assets/img/logo.png" style="width: 50px" />
                        <div style="width: 2px; background-color: black; height: 60px; margin: 0 20px"></div>
                    </template>
                    <span class="logo"> {{ VUE_APP_LOGIN_TITLE }} </span>
                </div>
                <div class="inputRow">
                    <a-input v-model:value="userName" placeholder="用户名" size="large">
                        <template #prefix>
                            <my-icon iconName="UserOutlined" style="color: rgba(0, 0, 0, 0.45)"></my-icon>
                        </template>
                        <template #suffix>
                            <a-tooltip title="请在这里输入你的用户名">
                                <my-icon iconName="InfoCircleOutlined" style="color: rgba(0, 0, 0, 0.45)"></my-icon>
                            </a-tooltip>
                        </template>
                    </a-input>
                </div>
                <div class="inputRow">
                    <a-input-password v-model:value="userPassword" placeholder="密码" size="large">
                        <template #prefix>
                            <my-icon iconName="LockOutlined" style="color: rgba(0, 0, 0, 0.45)"></my-icon>
                        </template>
                    </a-input-password>
                </div>
                <div class="inputRow">
                    <a-button type="primary" block @click="login" :loading="loading" size="large">
                        登录
                    </a-button>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import { login, getUserLoginInfo } from '@/api/login';
import md5 from 'md5';

export default {
    name: 'Login',
    props: {
        // msg: String
    },
    created: function () { },
    mounted() { },
    data: () => {
        return {
            loading: false,
            userName: null,
            userPassword: null,
            // menuList: []
            factoryList: [],
            factoryCode: '',
            isAdmin: false,
            cid: '',
        }
    },
    methods: {
        login() {
            var name = this.userName
            var pwd = this.userPassword

            console.log('name:', name)

            if (name && name.trim() != '') {
                if (pwd && pwd.trim() != '') {
                    this.httpLogin(name, pwd)
                } else {
                    this.$message.error('密码不能为空!')
                }
            } else {
                this.$message.error('用户名不能为空!')
            }
        },
        httpLogin(name, pwd) {
            // 不执行不行吗
            this.loading = true
            const body = {
                username: name,
                password: md5(pwd),
            }

            login(body)
                .then((data) => {
                    // this.loading = false

                    if (data && data.access_token) {
                        // 登陆成功
                        // this.$message.success('登录成功!')
                        getLocalData.clear() // 清空缓存
                        this.$store.commit('clearPage');

                        console.log('token:', data.access_token)
                        getLocalData.setItem('token', data.access_token)

                        getUserLoginInfo({})
                            .then((infodata) => {
                                if (infodata) {
                                    this.loading = false
                                    this.$message.success('登录成功!')
                                    if (infodata.companys && infodata.companys.length > 0) {
                                        getLocalData.setItem('companyInfo', JSON.stringify(infodata.companys[0]))
                                    }

                                    console.log('userdata.data:', infodata.user)
                                    getLocalData.setItem('userInfo', JSON.stringify(infodata.user))
                                    getLocalData.setItem('role', JSON.stringify(infodata.roles[0]))

                                    console.log('menudata.data:', infodata.menus)
                                    getLocalData.setItem('menuList', JSON.stringify(infodata.menus) || []);

                                    this.authFormat(infodata.menus);
                                    if (infodata.user.tenantType === '1') {
                                        this.toBatch();
                                    } else {
                                        this.toMain()
                                    }
                                }
                            })
                            .catch((e) => {
                                this.$message.error('登录失败');
                                this.loading = false
                                console.error(e)
                            })
                    } else {
                        //
                    }
                })
                .catch((e) => {
                    this.loading = false
                    console.error(e)
                })
        },

        toMain() {
            this.$router.push('main')
        },
        toBatch() {
            this.$router.push('/temp/zjc-gongyingshanggongzuotai');
        },
        /** 保存权限 字典 */
        authFormat(menuList = null) {
            if (menuList) {
                const authmap = {}
                menuList.forEach((element) => {
                    const path = element.url
                    const auth = element.auth
                    if (auth) {
                        const auths = auth.split(',').map((item) => {
                            const items = item.split(':')
                            if (items.length > 1) {
                                return items[1]
                            }
                            return null
                        })
                        authmap[path] = auths
                    }
                })
                getLocalData.setItem('auth', JSON.stringify(authmap))
            }
        },
    },
    computed: {
        VUE_APP_MODE() {
            return process.env.VUE_APP_MODE;
        },
        VUE_APP_LOGIN_TITLE() {
            return process.env.VUE_APP_LOGIN_TITLE;
        }
    }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->

<style scoped lang="scss">
a-input,
a-input-password {
    width: 100%;
    height: 50px;
}

.login {
    font-family: 'alibabapuhuiti-heavy';
    position: fixed;
    display: flex;
    justify-content: center;
    width: 100%;
    height: 100%;
    background-repeat: no-repeat;
    background-position: center;
    background-image: url(../assets/img/login.jpg);
}

.login_bg_m {
    position: absolute;
    bottom: 0;
    right: 0;
    width: 200px;
}

.hw100 {
    width: 100vw;
    height: 100vh;
    /* background-color: rgba(255, 255, 255, 0.5); */
    display: flex;
    flex-direction: column;
    align-items: flex-end;
    justify-content: center;
    margin-right: 20%;
    padding-bottom: 100px;
    /* border: 1px solid red; */
}

.loginBox {
    width: 23rem;
    margin: 2rem;
    /* border: 1px solid red; */
}

.inputRow {
    height: 4rem;
    display: flex;
    flex-direction: row;
    align-items: center;
}

.logo {
    /* margin-left: 15px; */
}

.caigouTitle {
    display: flex;
    flex-direction: row;
    align-items: center;
    justify-content: center;
    font-weight: bold;
    font-size: 34px;
    margin-bottom: 20px
}
</style>
